import axios from "axios"

import { BASE_URL } from "../../../../global"
import type { AiRecommendation } from "./aiLessonPlanningTypes"

const SOURCE_ID = /^(?:EN|MA)_(ONLINE|WORKSHEET)_(\d+)$/

export function recommendationAssignKey(sourceId: string): string | null {
  const match = SOURCE_ID.exec(sourceId || "")
  if (!match) return null
  return `${match[1]}:${match[2]}`
}

export function lessonActivityAssignKey(activity: {
  activity_type?: number | string
  fk_activity_node_id?: number | string | null
}): string | null {
  const id = activity?.fk_activity_node_id
  if (id == null || id === "") return null
  const type = Number(activity.activity_type)
  if (type === 0) return `ONLINE:${id}`
  if (type === 7) return `WORKSHEET:${id}`
  return null
}

function toCreateActivity(item: AiRecommendation): Record<string, unknown> | null {
  const match = SOURCE_ID.exec(item.sourceId || "")
  if (!match) return null
  const kind = match[1]
  const numericId = Number(match[2])
  const subjectId = item.subject === "english" ? 1 : 2
  const isWorksheet = kind === "WORKSHEET"

  return {
    id: numericId,
    name: item.title,
    subject_id: subjectId,
    topicID: 0,
    coin: isWorksheet ? 20 : 2,
    duration: isWorksheet ? "20 mins" : "",
    is_homework: 0,
    type: isWorksheet ? "Worksheet" : "Online Activities",
    tutor_comments: "",
    activity_node_id: numericId,
    activity_type: isWorksheet ? 7 : 0,
    level_id: "",
    level_name: "",
    topic_name: item.strand || "",
  }
}

export async function assignAiRecommendations(params: {
  items: AiRecommendation[]
  isHomework: boolean
  authUser: string
  sessionKey: string
  studentKey: string
}): Promise<number> {
  const activities = params.items
    .map(toCreateActivity)
    .filter((activity): activity is Record<string, unknown> => activity != null)

  if (activities.length === 0) {
    throw new Error("These recommendations cannot be assigned")
  }

  axios.defaults.headers.common["Authorization"] = `Bearer ${params.authUser}`
  await axios.post(BASE_URL + "activity/createActivities", {
    activities,
    is_homework: params.isHomework ? 1 : 0,
    lesson_key: localStorage.getItem("lesson_key") || "",
    session_key: params.sessionKey,
    student_key: params.studentKey,
  })

  return activities.length
}
